import { IDelLayerData } from '@/framework';
import { ILayerProps } from '@/version-types';

/** 历史记录类型 **/
export enum HistoryType {
    /** 成组 */
    PACK = 'pack:o-group',
    /** 解组 */
    UNPACK = 'unpack:o-group',
    /** 合并 */
    MERGE = 'merge:o-group',
}

/** 合并 */
export type IHistoryMergeData = {
    /** 删除的数据 */
    delData: IDelLayerData;
    /** 插入的数据 */
    insertData: ILayerProps;
};

/** 成组 */
export type IHistoryPackData = {
    /** 渲染数据，多人协作时，需要同步 */
    item: {
        childIndexes: number[];
        childIds: string[];
        layer: ILayerProps;
        layerIndex: number;
    };
};

/** 解组 */
export type IHistoryUnpackData = {
    /** 渲染数据，多人协作时，需要同步 */
    item: {
        layer: ILayerProps;
        layerIndex: number;
    };
};
